import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

export const chevron = variants({
  base: [cn('absolute right-sm mx-sm transition-transform')],
  variants: {
    state: {
      default: [cn('rotate-0 transform')],
      open: [cn('rotate-180 transform')],
    },
  },
});

export const STICKY_TABLE_HEAD_CLASS = cn(
  // Calculation for "top" = var(--sticky-header-height) + border-spacing-y-sm
  'sticky top-[calc(var(--sticky-header-height)+var(--spacing-sm))] z-10 duration-0 will-change-[top]',
);

export const SCROLL_COLLAPSE_EASING_DURATION_CLASS = 'duration-300 ease-out';
